
(function($){

    "use strict";

    $.parallaxing = function() {
        if( (!$.isMobile('Android') && !$.isMobile('iPhone') && !$.isMobile('iPad') && !$.isMobile('IEMobile')) ) {
            var _offset = parseInt($(window).height()/5);
            var _selector = ".parallax-ani:not('on--screen')";
            $.each( $(_selector), function() {
                if( $(this).isOnScreen( _offset ) ) {
                    var _parallaxCss = $(this).attr('class').replace(/animated_/i, 'animated ');
                    $(this).attr('class', _parallaxCss).addClass('on--screen');
                }
            });
        } else {
            $('.parallax-ani').addClass('animated on--screen');
        }
    };

    $.fn.isOnScreen = function(offset) {
        var viewport = {};
        viewport.top = $(window).scrollTop();
        viewport.bottom = viewport.top + $(window).height();
        var bounds = {};
        bounds.top = this.offset().top + offset;
        bounds.bottom = bounds.top + this.outerHeight();
        return ((bounds.top <= viewport.bottom) && (bounds.bottom >= viewport.top));
    };

    function pageLoaded() {
        setTimeout( function() {
            $.parallaxing();
        }, 300);
        //console.log('loaded ui-ani');
    };

    // add livewire navigated listener
    document.addEventListener('livewire:navigated', function () {
        pageLoaded();
    });

    // livewire is not installed
    if (typeof Livewire === "undefined") {
        // do jquery basic stuff after page has loaded
        $(function(){
            pageLoaded();
        });
    }

}( jQuery ));

var _aniScrollDebouncingHandler = $._debounce(function() {
    "use strict";
    $.parallaxing();
},50);

var _aniResizeDebouncingHandler = $._debounce(function() {
    "use strict";
    $.parallaxing();
},100);

$(window).bind('scroll', function(e) { "use strict"; _aniScrollDebouncingHandler(e); });
$('#app').bind('scroll', function(e) { "use strict"; _aniScrollDebouncingHandler(e); });
$(window).bind('resize', function(e) { "use strict"; _aniResizeDebouncingHandler(e); });
